import Toast from 'light-toast';

enum MCDNetworkStatusType {
  'wifi' = 1,
  '2g' = 2,
  '3g' = 3,
  '4g' = 4,
  '5g' = 5,
  'unknown' = -1,
  'none' = 0
}
// 用于跟踪当前打开的 App 尝试，防止多次调用导致的内存泄漏
let currentTimer: NodeJS.Timeout | null = null;
let currentHasOpened = false;

// https://zhuanlan.zhihu.com/p/141656734

const hasSafeArea = (type: any) => {
  const iphoneTypeList = [
    { "model": "iPhone 6/7/8", "name": 'iPhone 6' },
    { "model": "iPhone 6", "name": 'iPhone 6' },
    { "model": "iPhone 7", "name": 'iPhone 7' },
    { "model": "iPhone 8", "name": 'iPhone 8' },
    { "model": "iPhone1,1", "name": "iPhone" },
    { "model": "iPhone1,2", "name": "iPhone3GS" },
    { "model": "iPhone3,2", "name": "iPhone 4" },
    { "model": "iPhone3,3", "name": "iPhone 4" },
    { "model": "iPhone4,1", "name": "iPhone 4S" },
    { "model": "iPhone5,1", "name": "iPhone 5" },
    { "model": "iPhone5,2", "name": "iPhone 5" },
    { "model": "iPhone5,3", "name": "iPhone 5c" },
    { "model": "iPhone5,4", "name": "iPhone 5c" },
    { "model": "iPhone6,1", "name": "iPhone 5s" },
    { "model": "iPhone6,2", "name": "iPhone 5s" },
    { "model": "iPhone7,1", "name": "iPhone 6 Plus" },
    { "model": "iPhone7,2", "name": "iPhone 6" },
    { "model": "iPhone8,1", "name": "iPhone 6s" },
    { "model": "iPhone8,2", "name": "iPhone 6s Plus" },
    { "model": "iPhone8,4", "name": "iPhone SE" },
    { "model": "iPhone9,1", "name": "iPhone 7" },
    { "model": "iPhone9,2", "name": "iPhone 7 Plus" },
    { "model": "iPhone9,3", "name": "iPhone 7" },
    { "model": "iPhone9,4", "name": "iPhone 7 Plus" },
    { "model": "iPhone10,1", "name": "iPhone 8" },
    { "model": "iPhone10,2", "name": "iPhone 8 Plus" },
    { "model": "iPhone10,4", "name": "iPhone 8" },
    { "model": "iPhone10,5", "name": "iPhone 8 Plus" },
  ]
  return iphoneTypeList.findIndex((item: any) => item.model === type);
}

const getNetWorkType = () => {
  var ua:any = navigator.userAgent;
  var networkStr = ua.match(/NetType\/\w+/) ? ua.match(/NetType\/\w+/)[0] : 'NetType/other';
  networkStr = networkStr.toLowerCase().replace('nettype/', '');
  var networkType: any;
  switch (networkStr) {
    case 'wifi':
      networkType = 'wifi';
      break;
    case '4g':
      networkType = '4g';
      break;
    case '3g':
      networkType = '3g';
      break;
    case '3gnet':
      networkType = '3g';
      break;
    case '2g':
      networkType = '2g';
      break;
    default:
      networkType = 'other';
  }
  return Promise.resolve(MCDNetworkStatusType[networkType])
}

/**
 * 环境检测函数
 */
const getEnv = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isWebInWeapp = ua.includes('micromessenger');
  const isWeb = !ua.includes('mcd-ios') && !ua.includes('mcd-android') && !ua.includes('mcd-harmony');
  const isAlipay = ua.includes('alipay');
  const isIos = ua.includes('mcd-ios');
  const isAndroid = ua.includes('mcd-android');
  const isHarmony = ua.includes('mcd-harmony');
  const isApp = isIos || isAndroid || isHarmony;

  const envInfo = {
    isWebInWeapp,
    isWeb,
    isAlipay,
    isIos,
    isAndroid,
    isHarmony,
    isApp,
  }
  // console.log('getEnv', envInfo);
  return envInfo
};

const getDownloadLink = () => {
  if (getEnv().isIos) {
    return 'https://apps.apple.com/cn/app/id1054598922';
  } else {
    return 'https://a.app.qq.com/o/simple.jsp?pkgname=com.mcdonalds.gma.cn'
  }
};
/**
 * 在普通浏览器中尝试打开 App，如果失败则跳转下载
 * @param appUrl App 协议链接（如 mcdapp://...）
 * @param timeout 超时时间（毫秒），默认 2000ms
 */
const tryOpenAppOrDownload = (appUrl: string, timeout: number = 2000) => {
  // 如果是微信小程序环境，直接返回（使用 wx-open-launch-app）
  if (getEnv().isWebInWeapp) {
    return;
  }

  if (getEnv().isHarmony) {
    Toast.info('请至应用市场下载麦当劳APP', 2000)
    return;
  }

  // 清理之前的监听器和定时器
  if (currentTimer) {
    clearTimeout(currentTimer);
    currentTimer = null;
  }

  // 处理页面可见性变化
  const handleVisibilityChange = () => {
    if (document.hidden) {
      // 页面隐藏，说明成功打开了 App
      currentHasOpened = true;
      cleanup();
    }
  };

  // 清理函数
  const cleanup = () => {
    if (currentTimer) {
      clearTimeout(currentTimer);
      currentTimer = null;
    }
    if (handleVisibilityChange) {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    }
  };

  // 设置定时器
  currentTimer = setTimeout(() => {
    if (!currentHasOpened) {
      // 超时时间内页面未隐藏，说明未打开 App，跳转下载
      window.location.href = getDownloadLink();
      cleanup();
    }
  }, timeout);

  // 监听页面可见性变化
  document.addEventListener('visibilitychange', handleVisibilityChange);

  // 尝试打开 App
  try {
    window.location.href = appUrl;
  } catch (error) {
    console.error('打开 App 失败:', error);
    window.location.href = getDownloadLink();
    cleanup();
  }
};

const getCt = () => {
  let ct = 10;
  const userAgent: any = navigator.userAgent.toLowerCase();
  if (userAgent.includes("mcd-ios")) {
    ct = 101;
  } else if (userAgent.includes("mcd-android")) {
    ct = 102;
  } else if (userAgent.includes('mcd-harmony')) {
    ct = 103;
  } else if (userAgent.includes("micromessenger")) {
    ct = 31;
  } else if (userAgent.includes("alipayclient")) {
    ct = 32;
  }
  return ct
}

export {
  hasSafeArea,
  getNetWorkType,
  getEnv,
  tryOpenAppOrDownload,
  getCt
}
